/**
 * 🔒 SECURE FREE VARIANT HIDING + PRODUCT CARD PRICE FIX
 * Hides and disables free variants everywhere + Shows correct prices on product cards
 */

(function() {
  'use strict';

  // ✅ Your free variant IDs
  const FREE_KEFIR_VARIANTS = [
    '42710002040929',
    '42710002139233',
    '42710001844321',
    '42710000107617',
    '42709996896353'
  ];
  
  const FREE_BAG_VARIANT = '42710002401377';
  
  const ALL_FREE_VARIANTS = [...FREE_KEFIR_VARIANTS, FREE_BAG_VARIANT];

  console.log('[Free Variant Security] Initializing...');

  // ========================================
  // 💰 PART 1: FIX PRODUCT CARD PRICES (RUN FIRST!)
  // ========================================
  
  // Hide $0.00 prices immediately with CSS
  const priceStyleId = 'hw-hide-zero-prices';
  if (!document.getElementById(priceStyleId)) {
    const priceStyle = document.createElement('style');
    priceStyle.id = priceStyleId;
    priceStyle.innerHTML = `
      /* Hide $0.00 prices immediately while JS loads */
      .price-item:has(span:contains("$0.00")),
      .price__last:has(span:contains("$0.00")),
      .card-price .price-item span:contains("$0.00") {
        opacity: 0 !important;
        visibility: hidden !important;
      }
    `;
    document.head.appendChild(priceStyle);
  }
  
  function fixProductCardPrices() {
    console.log('[Product Card Prices] Fixing prices...');
    
    // Find all product cards
    document.querySelectorAll('.card-product, .product-card, [data-product-id], [class*="product"]').forEach(function(productCard) {
      // Skip if already processed
      if (productCard.hasAttribute('data-price-fixed')) return;
      
      const priceContainer = productCard.querySelector('.card-price, .price, [class*="price"]');
      if (!priceContainer) return;
      
      const priceText = priceContainer.textContent;
      
      // Only process if showing $0.00
      if (priceText.includes('$0.00') || priceText.includes('$0')) {
        const productLink = productCard.querySelector('a[href*="/products/"]');
        
        if (productLink) {
          const href = productLink.getAttribute('href');
          const handleMatch = href.match(/\/products\/([^?#\/]+)/);
          
          if (handleMatch) {
            const handle = handleMatch[1];
            
            // Mark as being processed
            productCard.setAttribute('data-price-fixing', 'true');
            
            // Fetch product data
            fetch(`/products/${handle}.js`)
              .then(function(res) { return res.json(); })
              .then(function(product) {
                // Filter out free variants (price = 0 or in free list)
                const paidVariants = product.variants.filter(function(v) {
                  return v.price > 0 && !ALL_FREE_VARIANTS.includes(v.id.toString());
                });
                
                if (paidVariants.length > 0) {
                  // Get lowest paid price
                  const lowestPrice = Math.min.apply(null, paidVariants.map(function(v) { return v.price; }));
                  const formattedPrice = formatMoney(lowestPrice);
                  
                  // Find all price displays that show $0
                  const zeroPriceElements = productCard.querySelectorAll('.price-item span, .price__last span, [class*="price"] span');
                  
                  zeroPriceElements.forEach(function(el) {
                    if (el.textContent.includes('$0')) {
                      el.textContent = formattedPrice;
                      el.style.opacity = '1';
                      el.style.visibility = 'visible';
                    }
                  });
                  
                  // Mark as fixed
                  productCard.setAttribute('data-price-fixed', 'true');
                  productCard.removeAttribute('data-price-fixing');
                  
                  console.log('[Product Card Prices] ✅ Fixed:', product.title, '→', formattedPrice);
                } else {
                  // No paid variants, hide the price completely
                  if (priceContainer) {
                    priceContainer.style.display = 'none';
                  }
                  productCard.setAttribute('data-price-fixed', 'true');
                  productCard.removeAttribute('data-price-fixing');
                }
              })
              .catch(function(err) {
                console.warn('[Product Card Prices] Could not fetch product:', err);
                // Fallback: just hide the $0.00 price
                if (priceContainer) {
                  priceContainer.style.display = 'none';
                }
                productCard.removeAttribute('data-price-fixing');
              });
          }
        }
      }
    });
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  // ========================================
  // 🔒 PART 2: HIDE FREE VARIANTS ON PRODUCT PAGES
  // ========================================
  
  function hideAndDisableFreeVariants() {
    // 🔒 METHOD 1: Hide radio buttons with "Free" text
    document.querySelectorAll('input[type="radio"]').forEach(function(radio) {
      const label = document.querySelector(`label[for="${radio.id}"]`);
      const labelText = label ? label.textContent.trim().toLowerCase() : '';
      const radioValue = radio.value.toLowerCase();
      const variantId = radio.getAttribute('data-variant-id');
      
      // Check if it's a free variant by text OR variant ID
      if (labelText === 'free' || radioValue === 'free' || ALL_FREE_VARIANTS.includes(variantId)) {
        // Hide the input
        radio.style.display = 'none';
        radio.style.visibility = 'hidden';
        radio.disabled = true;
        radio.checked = false;
        
        // Hide the label
        if (label) {
          label.style.display = 'none';
          label.style.visibility = 'hidden';
          label.style.pointerEvents = 'none';
        }
        
        // Hide parent container if it exists
        const parentSwatch = radio.closest('.swatch-element, .product-form__label');
        if (parentSwatch) {
          parentSwatch.style.display = 'none';
          parentSwatch.style.visibility = 'hidden';
        }
        
        console.log('[Free Variant Security] ✅ Disabled radio:', radio.id);
      }
    });

    // 🔒 METHOD 2: Hide select dropdown options
    document.querySelectorAll('select option').forEach(function(option) {
      const optionText = option.textContent.trim().toLowerCase();
      const optionValue = option.value;
      const dataValue = option.getAttribute('data-value');
      
      if (optionText === 'free' || ALL_FREE_VARIANTS.includes(optionValue) || ALL_FREE_VARIANTS.includes(dataValue)) {
        option.disabled = true;
        option.style.display = 'none';
        option.remove(); // Completely remove from DOM
        console.log('[Free Variant Security] ✅ Removed option:', optionText);
      }
    });

    // 🔒 METHOD 3: Hide swatch buttons in quick-add
    document.querySelectorAll('.swatch-element').forEach(function(swatch) {
      const dataValue = swatch.getAttribute('data-value');
      const swatchText = swatch.textContent.trim().toLowerCase();
      
      if (dataValue && dataValue.toLowerCase() === 'free' || swatchText.includes('free')) {
        swatch.style.display = 'none !important';
        swatch.style.visibility = 'hidden !important';
        swatch.style.opacity = '0 !important';
        swatch.remove(); // Remove from DOM completely
        console.log('[Free Variant Security] ✅ Removed swatch:', dataValue);
      }
    });

    // 🔒 METHOD 4: Prevent form submission with free variants
    document.querySelectorAll('form').forEach(function(form) {
      // Skip if already protected
      if (form.hasAttribute('data-hw-protected')) return;
      form.setAttribute('data-hw-protected', 'true');
      
      form.addEventListener('submit', function(e) {
        const variantSelect = form.querySelector('select[name="id"]');
        const selectedVariantId = variantSelect ? variantSelect.value : null;
        
        if (selectedVariantId && ALL_FREE_VARIANTS.includes(selectedVariantId)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.warn('[Free Variant Security] 🚫 Blocked submission of free variant!');
          alert('This variant is not available for purchase.');
          return false;
        }
        
        // Also check radio buttons
        const checkedRadio = form.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          const variantId = checkedRadio.getAttribute('data-variant-id');
          const radioValue = checkedRadio.value.toLowerCase();
          
          if (radioValue === 'free' || ALL_FREE_VARIANTS.includes(variantId)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            console.warn('[Free Variant Security] 🚫 Blocked submission of free variant via radio!');
            alert('This variant is not available for purchase.');
            return false;
          }
        }
      }, true);
    });

    // 🔒 METHOD 5: Prevent clicking on free variant labels
    document.querySelectorAll('label').forEach(function(label) {
      const labelText = label.textContent.trim().toLowerCase();
      const forAttr = label.getAttribute('for');
      
      if (labelText.includes('free') && forAttr) {
        const input = document.getElementById(forAttr);
        if (input) {
          const variantId = input.getAttribute('data-variant-id');
          if (ALL_FREE_VARIANTS.includes(variantId) || input.value.toLowerCase() === 'free') {
            label.style.pointerEvents = 'none';
            label.style.cursor = 'not-allowed';
            label.style.opacity = '0';
            label.style.display = 'none';
            label.onclick = function(e) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            };
          }
        }
      }
    });

    // 🔒 METHOD 6: Remove free variants from variant data (if exists)
    if (window.productVariants) {
      window.productVariants = window.productVariants.filter(function(variant) {
        return !ALL_FREE_VARIANTS.includes(variant.id.toString());
      });
    }

    // 🔒 METHOD 7: Inject CSS to hide by attribute selectors
    const styleId = 'hw-hide-free-variants';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        /* Hide free variant radio buttons */
        input[value="Free"],
        input[value="free"],
        input[data-variant-id="${ALL_FREE_VARIANTS.join('"], input[data-variant-id="')}"] {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
        }
        
        /* Hide free variant labels */
        label[for*="Free"],
        label[for*="free"],
        .product-form__label:has(input[value="Free"]),
        .product-form__label:has(input[value="free"]) {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
        
        /* Hide free variant swatches */
        .swatch-element[data-value="Free"],
        .swatch-element[data-value="free"],
        .swatch-element.free {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
        }
        
        /* Hide free variant options in select */
        option[value="${ALL_FREE_VARIANTS.join('"], option[value="')}"] {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }
  }

  // ========================================
  // 🚀 EXECUTION & OBSERVERS
  // ========================================

  // 💰 Fix prices IMMEDIATELY (highest priority)
  fixProductCardPrices();

  // 🔒 Hide variants
  hideAndDisableFreeVariants();

  // 🔒 Run after DOM loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      fixProductCardPrices();
      hideAndDisableFreeVariants();
    });
  }

  // 🔒 Run when page is fully loaded
  window.addEventListener('load', function() {
    fixProductCardPrices();
    hideAndDisableFreeVariants();
  });

  // 🔒 Watch for dynamic content (quick-add modals, AJAX, infinite scroll)
  const observer = new MutationObserver(function(mutations) {
    let shouldCheckVariants = false;
    let shouldCheckPrices = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check for variant selectors
            if (node.matches && (
              node.matches('form') ||
              node.matches('.variants-popup') ||
              node.matches('.quickshop') ||
              node.matches('.swatch') ||
              node.matches('[class*="variant"]') ||
              node.querySelector('form') ||
              node.querySelector('.swatch')
            )) {
              shouldCheckVariants = true;
            }
            
            // Check for product cards
            if (node.matches && (
              node.matches('.card-product') ||
              node.matches('.product-card') ||
              node.matches('[class*="product"]') ||
              node.querySelector('.card-product') ||
              node.querySelector('.product-card')
            )) {
              shouldCheckPrices = true;
            }
          }
        });
      }
    });
    
    if (shouldCheckVariants) {
      setTimeout(hideAndDisableFreeVariants, 50);
    }
    
    if (shouldCheckPrices) {
      setTimeout(fixProductCardPrices, 10); // Very fast for new cards
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 🔒 Run on Shopify theme events
  document.addEventListener('shopify:section:load', function() {
    fixProductCardPrices();
    hideAndDisableFreeVariants();
  });
  
  document.addEventListener('shopify:block:select', hideAndDisableFreeVariants);
  
  // 🔒 Run on common modal/popup events
  document.addEventListener('modal:opened', hideAndDisableFreeVariants);
  document.addEventListener('quickview:opened', hideAndDisableFreeVariants);

  // 🔒 Run periodically (backup safety net)
  setInterval(hideAndDisableFreeVariants, 2000);
  setInterval(fixProductCardPrices, 3000); // Check for new cards

  console.log('[Free Variant Security] ✅ All protection methods active');
  console.log('[Product Card Prices] ✅ Price fixer active');

})();